import {
    Anchor,
    Box,
    Button,
    Center,
    Grid,
    Group,
    List,
    Paper,
    Stack,
    Text,
    ThemeIcon,
    Title,
} from '@mantine/core';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { Icons } from 'src/components/ui/Icons';

export default function SignUpType() {
    const TITLE_SIZE = 44;
    const PANEL_MIN_HEIGHT = 560;

    return (
        <>
            <Paper shadow="md">
                <Grid gutter={0} align="stretch">
                    <Grid.Col
                        span={{ base: 12, md: 6, lg: 6 }}
                        style={{ display: 'flex' }}
                    >
                        <Box bg="white" style={{ flex: 1 }} mih={{ md: PANEL_MIN_HEIGHT }}>
                            <Center h="100%" p={{ base: 'lg', md: 'xl' }}>
                                <Stack
                                    w="100%"
                                    maw={520}
                                    gap={0}
                                >
                                    <Stack gap="xl">

                                        <Group gap="sm" align="center">
                                            <ThemeIcon size={60} radius="md" variant="light" color="dark">
                                                <Icon icon={Icons.venue} width={26} />
                                            </ThemeIcon>
                                            <Box>
                                                <Title order={2} size={TITLE_SIZE} fw={900} style={{ lineHeight: 1.05 }}>
                                                    Venue account
                                                </Title>
                                                <Text c="dimmed" size="md">
                                                    For clubs, bars, hotels, restaurants, event spaces, and any business that takes bookings.
                                                </Text>
                                            </Box>
                                        </Group>

                                        <List
                                            spacing="sm"
                                            icon={
                                                <ThemeIcon size={22} radius="xl" variant="light" color="dark">
                                                    <Icon icon={Icons.successCircle} width={14} />
                                                </ThemeIcon>
                                            }
                                        >
                                            <List.Item>Set up your venue profile and services</List.Item>
                                            <List.Item>Manage staff, availability, and clients</List.Item>
                                            <List.Item>Accept and organize bookings in one place</List.Item>
                                        </List>
                                    </Stack>

                                    <Button
                                        component={Link}
                                        to="/venue-sign-up"
                                        size="lg"
                                        radius="xl"
                                        w={260}
                                        mt="xl"
                                    >
                                        Continue as Venue
                                    </Button>

                                </Stack>
                            </Center>
                        </Box>
                    </Grid.Col>

                    <Grid.Col span={{ base: 12, md: 6, lg: 6 }} style={{ display: 'flex' }}>
                        <Box
                            mih={{ md: PANEL_MIN_HEIGHT }}
                            style={{
                                flex: 1,
                                backgroundImage: [
                                    'radial-gradient(900px circle at 72% 38%, rgba(73, 164, 255, 0.26) 0%, transparent 58%)',
                                'radial-gradient(760px circle at 22% 72%, rgba(24, 233, 199, 0.18) 0%, transparent 60%)',
                                'radial-gradient(680px circle at 55% 108%, rgba(10, 112, 255, 0.14) 0%, transparent 66%)',
                                'radial-gradient(520px circle at 88% 16%, rgba(141, 184, 255, 0.16) 0%, transparent 62%)',
                                'linear-gradient(150deg, #02050d 0%, #06142a 44%, #0b2040 72%, #0f2b4f 100%)',
                                ].join(', '),
                            }}
                        >
                            <Center h="100%" p={{ base: 'lg', md: 'xl' }}>
                                <Stack
                                    gap={0}
                                    maw={520}
                                    style={{ color: 'white'}}
                                >
                                    <Stack gap="xl">
                                        <Group gap="sm" align="center">
                                            <ThemeIcon
                                                size={60}
                                                radius="md"
                                                variant="filled"
                                                styles={{ root: { backgroundColor: 'rgba(255,255,255,0.14)' } }}
                                            >
                                                <Icon icon={Icons.talent} width={26} />
                                            </ThemeIcon>
                                            <Box>
                                                <Title order={2} size={TITLE_SIZE} fw={900} style={{ lineHeight: 1.05 }}>
                                                    Talent account
                                                </Title>
                                                <Text size="md" style={{ opacity: 0.9, maxWidth: 520 }}>
                                                    For djs, artists, entertainers, and independent professionals who take bookings.
                                                </Text>
                                            </Box>
                                        </Group>

                                        <List
                                            spacing="sm"
                                            icon={
                                                <ThemeIcon
                                                    size={22}
                                                    radius="xl"
                                                    variant="filled"
                                                    styles={{ root: { backgroundColor: 'rgba(255,255,255,0.14)' } }}
                                                >
                                                    <Icon icon={Icons.successCircle} width={14} color="white" />
                                                </ThemeIcon>
                                            }
                                            styles={{
                                                itemLabel: { color: 'rgba(255,255,255,0.92)' },
                                            }}
                                        >
                                            <List.Item>Showcase your services and availability</List.Item>
                                            <List.Item>Keep your schedule organized, automatically</List.Item>
                                            <List.Item>Deliver a smoother booking experience for clients</List.Item>
                                        </List>
                                    </Stack>

                                    <Button
                                        component={Link}
                                        to="/talent-sign-up"
                                        variant="outline"
                                        color="white"
                                        size="lg"
                                        radius="xl"
                                        w={260}
                                        mt="xl"
                                        styles={{ root: { borderWidth: 2, backdropFilter: 'blur(8px)' } }}
                                    >
                                        Continue as Talent
                                    </Button>

                                </Stack>
                            </Center>
                        </Box>
                    </Grid.Col>
                </Grid>
            </Paper>
            <Center mt="xl">
                <Stack justify="center" align="center">
                    <Text size="sm">
                        Already have an account?{' '}
                        <Anchor component={Link} to="/sign-in" fw={600}>
                            Sign in
                        </Anchor>
                    </Text>
                    <Text size="xs" c="dimmed">
                        © 2026 Rockwell. All rights reserved.
                    </Text>
                </Stack>
            </Center>
        </>
    );
}
